"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactChartjs = require("react-chartjs-2");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// -------------- Bar Graph Impelementation -------------------- 
function BarGraph(data) {
  const Labels = data.data.map(lan => lan.label);
  const dataVal = data.data.map(val => val.value);
  const dataVal2 = data.data.map(val => val.value2);
  const colorr = data.data.map(col => col.color1);
  const colorr2 = data.data.map(col => col.color2);
  const graphData = {
    labels: Labels,
    datasets: [{
      label: 'Angular',
      backgroundColor: colorr,
      data: dataVal
    }, {
      label: 'React',
      backgroundColor: colorr2,
      data: dataVal2
    }]
  };
  const graphOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      yAxes: {
        scaleLabel: {
          display: true
        },
        ticks: {
          beginAtZero: true
        }
      }
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        align: 'start',
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: data.style.size == undefined || data.style.size == null || data.style.size == "" ? 6 : data.style.size
          }
        }
      }
    }
  };
  // console.log("height and width",data.style.width)
  return /*#__PURE__*/_react.default.createElement("div", {
    style: data.backstyle
  }, /*#__PURE__*/_react.default.createElement(_reactChartjs.Bar, {
    data: graphData,
    style: data.style,
    options: graphOptions
  }));
}
var _default = exports.default = BarGraph;